module.exports = __webpack_public_path__ + "watchDogsCaracter.png";